import { mapState } from 'vuex';
import { isEmpty, isEqual, cloneDeep } from 'lodash';
import Sortable from 'sortablejs';
const BASIC_HEADERS_VD = [{
  name: '_time',
  disabled: true
}, {
  name: '_value',
  disabled: true
}, {
  name: 'unit'
}, {
  name: 'dtwin_id'
}, {
  name: 'dtwin_title'
}, {
  name: 'state_id'
}, {
  name: 'state_identifier'
}, {
  name: 'state_title'
}, {
  name: 'external_id'
}, {
  name: 'twin_ancestor_ids'
}, {
  name: 'twin_tags'
}, {
  name: 'vdevice_groups'
}, {
  name: 'operational_status'
}, {
  name: 'connector_id'
}];
const BASIC_HEADERS_DT = [{
  name: '_time',
  disabled: true
}, {
  name: '_value',
  disabled: true
}, {
  name: 'unit'
}, {
  name: 'dtwin_id'
}, {
  name: 'dtwin_title'
}, {
  name: 'state_id'
}, {
  name: 'state_identifier'
}, {
  name: 'state_title'
}, {
  name: 'twin_ancestor_ids'
}, {
  name: 'twin_tags'
}];
export default {
  name: 'CoreCsvExportFormattingOptions',
  props: {
    value: {
      type: Object,
      default: () => ({
        headers: [],
        includeHeaders: true
      })
    },
    readonly: {
      type: Boolean,
      default: false
    },
    filterType: {
      type: String,
      required: true,
      default: 'digitalTwin'
    },
    customProperties: {
      type: Array,
      required: false,
      default: () => []
    },
    references: {
      type: Array,
      required: false,
      default: () => []
    },
    selectedDriversVariables: {
      type: Array,
      required: false,
      default: () => []
    },
    devicesCount: {
      type: Number,
      required: false,
      default: -1
    },
    driversCount: {
      type: Number,
      required: false,
      default: -1
    }
  },
  data() {
    return {
      internalModel: {
        ...this.value
      },
      headers: [],
      includeHeaders: true,
      staticHeaders: this.filterType === 'digitalTwin' ? cloneDeep(BASIC_HEADERS_DT) : cloneDeep(BASIC_HEADERS_VD)
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color']),
    themeMode() {
      return Boolean(this.$store.state.app.UiTheme) ? 'dark' : 'light';
    },
    tableLocalizations() {
      return {
        headers: [{
          text: '',
          sortable: false
        }, {
          text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.csvFormattingOptions.position'),
          sortable: false
        }, {
          text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.csvFormattingOptions.originalColumnName'),
          sortable: false
        }, {
          text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.csvFormattingOptions.newColumnName'),
          sortable: false
        }]
      };
    },
    mapValuesRules() {
      return [v => !/[,;]/.test(v) || this.$i18n_t('Common.commasNotAllowed'), v => !this.headers.find(f => {
        return f.name === v;
      }) || this.$i18n_t('Common.uniqueValue')];
    }
  },
  watch: {
    internalModel: {
      handler() {
        this.emitInput();
      },
      deep: true
    },
    value: {
      handler(newValue) {
        if (!isEqual(newValue, this.internalModel)) {
          this.internalModel = {
            ...this.value
          };
        }
      },
      deep: true
    },
    filterType() {
      this.setHeaders();
    },
    customProperties() {
      this.setHeaders();
    },
    references() {
      this.setHeaders();
    },
    selectedDriversVariables() {
      this.setHeaders();
    },
    headers() {
      this.initSortableTable();
      this.emitInput();
    },
    includeHeaders() {
      this.emitInput();
    }
  },
  mounted() {
    if (this.internalModel && !isEmpty(this.internalModel)) {
      if (isEmpty(this.internalModel.headers)) {
        this.setHeaders();
      } else {
        this.headers = this.internalModel.headers;
      }
      this.includeHeaders = this.internalModel.includeHeaders;
    } else {
      this.setHeaders();
    }
    this.initSortableTable();
  },
  methods: {
    initSortableTable() {
      const table = document.querySelector('.states-table tbody');
      Sortable.create(table, {
        handle: '.handle',
        onEnd: ({
          newIndex,
          oldIndex
        }) => {
          this.headers.splice(newIndex, 0, ...this.headers.splice(oldIndex, 1));
          this.emitInput();
        }
      });
    },
    emitInput() {
      this.$emit('input', {
        headers: this.headers,
        includeHeaders: this.includeHeaders,
        clusterPerPacket: this.internalModel.clusterPerPacket,
        formIsValid: this.includeHeaders ? !this.headers.some(el => {
          return el.mappedValue && /[,;]/.test(el.mappedValue);
        }) && !this.headers.some(element => {
          return this.headers.some(el => el.mappedValue && element.name === el.mappedValue);
        }) : true
      });
    },
    setHeaders() {
      this.staticHeaders = this.filterType === 'digitalTwin' ? cloneDeep(BASIC_HEADERS_DT) : cloneDeep(BASIC_HEADERS_VD);
      if (this.internalModel.clusterPerPacket) {
        const EXCLUDED_FROM_CLUSTERED = ['_value', 'unit', 'state_id', 'state_identifier', 'state_title'];
        this.staticHeaders = this.staticHeaders.filter(sh => !EXCLUDED_FROM_CLUSTERED.includes(sh.name));
      }
      let headers = cloneDeep(this.staticHeaders);
      headers = headers.concat(this.selectedDriversVariables.map(variable => {
        return {
          name: `${variable.title}`,
          count: variable.count,
          isInParsedState: true
        };
      }));
      this.headers = headers;
      if (this.customProperties.length) {
        this.customProperties.forEach(cp => {
          this.staticHeaders.push({
            name: `${cp.keyValue}`,
            count: cp.count,
            isCustomProperty: true
          });
        });
      }
      if (this.references.length) {
        this.references.forEach(ref => {
          this.staticHeaders.push({
            name: `${ref.key}`,
            count: ref.count,
            isReferenceProperty: true
          });
        });
      }
      if (this.internalModel.clusterPerPacket) {
        this.selectedDriversVariables.forEach(variable => {
          this.staticHeaders.push({
            name: `${variable.title}`,
            count: variable.count,
            isInParsedState: true
          });
        });
      }
    },
    getHeaderOptionString(item) {
      let itemText = '';
      let itemVariableText = '';
      if (item.isCustomProperty) {
        itemText = ` (${item.count} ${this.$i18n_t('Common.of')} ${this.devicesCount} ${this.$i18n_t(`BackgroundJobs.ScheduledExports.dialog.data.${this.filterType === 'digitalTwin' ? 'digitalTwins' : 'virtualDevices'}`)})`;
      } else if (item.isReferenceProperty) {
        itemVariableText = ` (${item.count} ${this.$i18n_t('Common.of')} ${this.devicesCount} ${this.$i18n_t('DigitalTwin.VirtualDevice.wizard.referenceIds')})`;
      } else if (item.isInParsedState) {
        itemVariableText = ` (${item.count} ${this.$i18n_t('Common.of')} ${this.driversCount} ${this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.deviceDrivers')})`;
      }
      return `${item.name}${itemText}${itemVariableText}`;
    }
  }
};